import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { api } from '../api/client';
import { Modal } from './Modal';
import { toast } from '../stores/toasts';
import type { LogType } from '../types';

interface AddLogModalProps {
  open: boolean;
  onClose: () => void;
  orderId: string;
  onAdded: () => void;
}

const TYPES: { value: LogType; label: string; emoji: string }[] = [
  { value: 'WORK', label: 'Ish', emoji: '🔧' },
  { value: 'PART', label: 'Ehtiyot qism', emoji: '🛠' },
  { value: 'NOTE', label: 'Izoh', emoji: '📝' },
];

export function AddLogModal({ open, onClose, orderId, onAdded }: AddLogModalProps) {
  const [type, setType] = useState<LogType>('WORK');
  const [description, setDescription] = useState('');
  const [qty, setQty] = useState('1');
  const [unitPrice, setUnitPrice] = useState('');

  const add = useMutation({
    mutationFn: () =>
      api.addLog(orderId, {
        type,
        description,
        qty: Number(qty) || 1,
        unitPrice: Number(unitPrice) || 0,
      }),
    onSuccess: () => {
      toast.success('Log qo\'shildi');
      setDescription('');
      setUnitPrice('');
      setQty('1');
      onAdded();
      onClose();
    },
    onError: (e: any) => toast.error(e?.message || 'Xatolik'),
  });

  function submit() {
    if (!description.trim()) {
      toast.warning('Tavsif kiriting');
      return;
    }
    add.mutate();
  }

  const showPrice = type !== 'NOTE';

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="➕ Log qo'shish"
      footer={
        <>
          <button className="btn" onClick={onClose}>Bekor</button>
          <button className="btn btn-primary" onClick={submit} disabled={add.isPending}>
            {add.isPending ? 'Saqlanmoqda...' : 'Saqlash'}
          </button>
        </>
      }
    >
      <div className="field">
        <label className="field-label">Turi</label>
        <div className="chips">
          {TYPES.map((t) => (
            <div
              key={t.value}
              className={`chip ${type === t.value ? 'active' : ''}`}
              onClick={() => setType(t.value)}
            >
              {t.emoji} {t.label}
            </div>
          ))}
        </div>
      </div>
      <div className="field">
        <label className="field-label">Tavsif</label>
        <textarea
          rows={3}
          placeholder={type === 'PART' ? 'Masalan: Moy filtri' : type === 'WORK' ? 'Masalan: Moy almashtirish' : 'Masalan: Mijozga xabar berildi'}
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />
      </div>
      {showPrice && (
        <div className="row" style={{ gap: 8 }}>
          <div className="field" style={{ flex: 1 }}>
            <label className="field-label">Soni</label>
            <input
              type="number"
              min="1"
              value={qty}
              onChange={(e) => setQty(e.target.value)}
            />
          </div>
          <div className="field" style={{ flex: 2 }}>
            <label className="field-label">Narxi (so'm)</label>
            <input
              type="number"
              min="0"
              placeholder="0"
              value={unitPrice}
              onChange={(e) => setUnitPrice(e.target.value)}
            />
          </div>
        </div>
      )}
      {showPrice && unitPrice && (
        <div className="muted" style={{ textAlign: 'right', marginBottom: 8 }}>
          Jami: <b className="amount">{(Number(qty) * Number(unitPrice)).toLocaleString('uz-UZ')} so'm</b>
        </div>
      )}
    </Modal>
  );
}
